
// CONSTANTS are all caps.
const NS = 'LoginButton';
const CLS = 'loginButton';
const WG = '.' + CLS + '-';

import axios from 'axios';
import Cognito from '../../../../global/js/cognito';
import {LoginModal} from '../../loginModal/js/loginModal';

export class LoginButton {
	constructor(el) {
		this.$el = $(el);
		this.loginModal = new LoginModal();
	}

	init() {
		this.$el.on('click', '.btn-login', (e)=> {
			e.preventDefault();
			const $loginModal = $('[data-role="login-modal"]');
			if ($loginModal.length) {
				$loginModal.removeClass('hidden');
			} else {
				this.loginModal.init();
			}
		});

		this.$el.on('click', '.btn-logout', (e)=> {
			e.preventDefault();
			this.logout();
		});
	}

	logout() {
		const userPool = Cognito.getUserPool({
			UserPoolId: window.cognitoUserPoolId,
			ClientId: window.cognitoAppClientId,
		});
		const cognitoUser = Cognito.getCognitoUser(null, userPool);
		if (cognitoUser) cognitoUser.signOut();
		this
			.signout()
			.then(()=> {
				window.location.reload();
			});
	}

	signout() {
		return axios.post('/api/customer/signout');
	}
}
